/** AP07 copy (one group per control; a ticket edits only its own file). */
export const ap07PtBr = {
  title: 'Fornecedores x razão',
  description:
    'Saldos a pagar, adiantamentos e impostos retidos em contas próprias, comparados separadamente aos respectivos saldos no razão na data de corte.',
  prerequisite: '',
  detail: {
    amountNote:
      'Cada valor é a diferença, em módulo, entre o razão e o saldo correspondente de contas a pagar, adiantamentos ou impostos retidos. Diferenças em sentidos opostos aparecem separadas e nunca se compensam.',
    truncated:
      'Mostrando {{shown}} de {{count}} pendências. A visão por conta só aparece quando a lista cabe inteira.',
    supplierFallback: 'Fornecedor {{id}}',
    accountFallback: 'Conta {{id}}',
    noAccount: 'Sem conta de fornecedor',
    noAdvanceAccount: 'Sem conta de adiantamento',
    openJournal: 'Abrir lançamento',
    directions: {
      higher: 'razão acima das contas a pagar',
      lower: 'razão abaixo das contas a pagar',
    },
    suppliers: {
      title: 'Diferenças por fornecedor',
    },
    advances: {
      title: 'Diferenças em adiantamentos a fornecedores',
      higher: 'razão acima do saldo de adiantamentos',
      lower: 'razão abaixo do saldo de adiantamentos',
      manualTitle: 'Lançamentos em adiantamentos sem fornecedor',
    },
    withholding: {
      title: 'Diferenças em impostos retidos de fornecedores',
      higher: 'razão acima dos impostos retidos em contas a pagar',
      lower: 'razão abaixo dos impostos retidos em contas a pagar',
      unmappedAccount: 'Conta não identificada',
      source: 'Origem: {{id}}',
      kindLabels: {
        ISS: 'ISS retido',
        IRRF: 'IRRF retido',
        INSS: 'INSS retido',
        PIS: 'PIS retido',
        COFINS: 'COFINS retida',
        CSLL: 'CSLL retida',
        other: 'Outro imposto retido',
      },
      coverageReasons: {
        AP_ACCOUNT_REUSED: 'Conta também usada para fornecedores ou adiantamentos',
        OTHER_TAX_MAPPING: 'Conta mapeada para imposto de outra origem',
        OTHER_TAX_RAIL: 'Conta usada por outra trilha tributária',
        GUIDE_RAIL: 'Conta usada para guias tributárias',
        SYSTEM_MAPPING: 'Conta usada por um mapeamento contábil do sistema',
        PAYROLL_JOURNAL: 'Lançamento de folha na conta de imposto retido',
        GUIDE_JOURNAL: 'Lançamento de guia na conta de imposto retido',
        NON_AP_JOURNAL: 'Lançamento sem origem de retenção de contas a pagar',
        NON_AP_ORIGIN_PRESENT: 'Conta compartilhada com outra origem contábil',
        AP_TAX_LINE_UNCLASSIFIED: 'Lançamento de contas a pagar sem tipo de retenção identificado',
        AP_TAX_LINE_WRONG_KIND: 'Tipo de retenção do lançamento não corresponde à conta',
        NO_MAPPING: 'Nenhuma conta contábil válida para a retenção na data do evento',
        AMBIGUOUS_MAPPING: 'Mais de uma conta contábil possível para a retenção',
      },
    },
    exclusions: {
      fxBook: {
        entity: 'Entidade',
        book: 'Livro contábil',
        apCurrency: 'Moeda de contas a pagar',
        bookCurrency: 'Moeda funcional do livro',
      },
      sourceTypes: { JOURNAL: 'Lançamento', BILL: 'Conta a pagar', PAYMENT: 'Pagamento' },
      status: 'Situação',
      statusValues: {
        DRAFT: 'Rascunho',
        SUBMITTED: 'Enviada',
        PENDING_APPROVAL: 'Aguardando aprovação',
        APPROVED: 'Aprovada',
        REJECTED: 'Rejeitada',
        PARTIALLY_PAID: 'Parcialmente paga',
        PAID: 'Paga',
        COMPLETED: 'Concluída',
        VOID: 'Cancelada',
        MIGRATED: 'Migrada',
        RECONCILED: 'Conciliado',
        REVERSED: 'Revertido',
      },
      bill: 'Conta a pagar vinculada',
      sourceEntity: 'Entidade do lançamento',
      currentEntity: 'Entidade atual',
      reason: 'Motivo da exclusão',
      reasons: {
        billEntityChanged: 'Entidade da conta alterada desde o lançamento',
        compoundJournalWithTransfer: 'Lançamento composto inclui conta transferida',
        relatedJournalWithTransfer: 'Lançamento relacionado a uma conta transferida',
        paymentJournalOtherEntity: 'Lançamento do pagamento pertence a outra entidade',
      },
      otherReason: 'Histórico da entidade não comprovado',
      journal: 'Lançamento vinculado',
      account: 'Conta contábil',
    },
    accounts: {
      title: 'Diferenças por conta',
      above: 'Razão acima',
      below: 'Razão abaixo',
      suppliers_one: '{{count}} fornecedor',
      suppliers_other: '{{count}} fornecedores',
    },
    manual: {
      title: 'Lançamentos manuais sem fornecedor',
      item: 'linha manual sem fornecedor',
    },
    other: {
      title: 'Outras pendências de fornecedores',
      item: 'pendência de fornecedor',
    },
  },
  observations: {
    AP07_OPENING_NOT_INDEPENDENT_one:
      '{{count}} lançamento de saldo inicial do razão importado, sem origem independente nas contas a pagar, fora da comparação',
    AP07_OPENING_NOT_INDEPENDENT_other:
      '{{count}} lançamentos de saldo inicial do razão importado, sem origem independente nas contas a pagar, fora da comparação',
    AP07_COMPOUND_PAYMENTS_one:
      '{{count}} pagamento em lançamento composto sem conta individual por fornecedor, fora da comparação',
    AP07_COMPOUND_PAYMENTS_other:
      '{{count}} pagamentos em lançamentos compostos sem conta individual por fornecedor, fora da comparação',
    AP07_VENDOR_ADVANCES_one: '{{count}} adiantamento a fornecedor, fora da comparação',
    AP07_VENDOR_ADVANCES_other: '{{count}} adiantamentos a fornecedores, fora da comparação',
    AP07_SHARED_WITHHOLDING_ACCOUNT_one:
      '{{count}} conta de imposto retido com movimentos de outra origem, fora da comparação de contas a pagar; conciliar nos controles de folha e tributos',
    AP07_SHARED_WITHHOLDING_ACCOUNT_other:
      '{{count}} contas de impostos retidos com movimentos de outra origem, fora da comparação de contas a pagar; conciliar nos controles de folha e tributos',
    AP07_WITHHOLDING_MAPPING_UNRESOLVED_one:
      '{{count}} retenção sem conta contábil identificada, fora da comparação',
    AP07_WITHHOLDING_MAPPING_UNRESOLVED_other:
      '{{count}} retenções sem conta contábil identificada, fora da comparação',
    AP07_REFUND_PAYMENTS_one: '{{count}} estorno ou ajuste de pagamento, fora da comparação',
    AP07_REFUND_PAYMENTS_other: '{{count}} estornos ou ajustes de pagamento, fora da comparação',
    AP07_FOREIGN_CURRENCY_BILLS_one: '{{count}} conta em moeda estrangeira, fora da comparação',
    AP07_FOREIGN_CURRENCY_BILLS_other: '{{count}} contas em moeda estrangeira, fora da comparação',
    AP07_FX_BOOK_one:
      'A moeda funcional do livro difere da moeda das contas a pagar: a comparação em valores não se aplica',
    AP07_FX_BOOK_other:
      'A moeda funcional do livro difere da moeda das contas a pagar: a comparação em valores não se aplica',
    AP07_AP_CURRENCY_UNRESOLVED_one:
      'Moeda funcional da entidade não resolvida: a comparação de contas a pagar com o razão não pode ser concluída',
    AP07_AP_CURRENCY_UNRESOLVED_other:
      'Moeda funcional da entidade não resolvida: a comparação de contas a pagar com o razão não pode ser concluída',
    AP07_PAYMENTS_AWAITING_RECONCILIATION_one:
      '{{count}} pagamento aguardando conciliação, fora da comparação',
    AP07_PAYMENTS_AWAITING_RECONCILIATION_other:
      '{{count}} pagamentos aguardando conciliação, fora da comparação',
    AP07_UNACCRUED_UNTRACED_PAYMENTS_one:
      '{{count}} pagamento sem conta a pagar contabilizada e sem lançamento rastreável, fora da comparação',
    AP07_UNACCRUED_UNTRACED_PAYMENTS_other:
      '{{count}} pagamentos sem conta a pagar contabilizada e sem lançamento rastreável, fora da comparação',
    AP07_MIGRATED_BILL_PAYMENTS_UNPOSTED_one:
      '{{count}} pagamento de conta migrada sem lançamento no razão, fora da comparação',
    AP07_MIGRATED_BILL_PAYMENTS_UNPOSTED_other:
      '{{count}} pagamentos de contas migradas sem lançamento no razão, fora da comparação',
    AP07_TRANSFERRED_BILL_HISTORY_UNPROVEN_one:
      '{{count}} origem histórica de conta transferida entre entidades sem comprovação da entidade no período, fora da comparação',
    AP07_TRANSFERRED_BILL_HISTORY_UNPROVEN_other:
      '{{count}} origens históricas de contas transferidas entre entidades sem comprovação da entidade no período, fora da comparação',
    other_one: '{{count}} item fora da comparação ({{code}})',
    other_other: '{{count}} itens fora da comparação ({{code}})',
  },
};

export const ap07En: typeof ap07PtBr = {
  title: 'Suppliers vs GL',
  description:
    'Payables, advances and supplier withholding taxes in their own accounts, compared separately with their general ledger balances at the cutoff date.',
  prerequisite: '',
  detail: {
    amountNote:
      'Each amount is the absolute difference between the general ledger and the corresponding payable, advance or withholding tax balance. Differences in opposite directions are listed separately and never offset each other.',
    truncated:
      'Showing {{shown}} of {{count}} open items. The per-account view only appears when the whole list fits.',
    supplierFallback: 'Supplier {{id}}',
    accountFallback: 'Account {{id}}',
    noAccount: 'No supplier account',
    noAdvanceAccount: 'No advance account',
    openJournal: 'Open journal entry',
    directions: {
      higher: 'GL above accounts payable',
      lower: 'GL below accounts payable',
    },
    suppliers: {
      title: 'Differences by supplier',
    },
    advances: {
      title: 'Supplier advance differences',
      higher: 'GL above the advance balance',
      lower: 'GL below the advance balance',
      manualTitle: 'Advance entries without a supplier',
    },
    withholding: {
      title: 'Supplier withholding tax differences',
      higher: 'GL above AP withholding taxes',
      lower: 'GL below AP withholding taxes',
      unmappedAccount: 'Account not identified',
      source: 'Source: {{id}}',
      kindLabels: {
        ISS: 'Withheld service tax (ISS)',
        IRRF: 'Withheld income tax (IRRF)',
        INSS: 'Withheld social security contribution (INSS)',
        PIS: 'Withheld PIS',
        COFINS: 'Withheld COFINS',
        CSLL: 'Withheld CSLL',
        other: 'Other withholding tax',
      },
      coverageReasons: {
        AP_ACCOUNT_REUSED: 'Account also used for suppliers or advances',
        OTHER_TAX_MAPPING: 'Account mapped to tax from another origin',
        OTHER_TAX_RAIL: 'Account used by another tax rail',
        GUIDE_RAIL: 'Account used for statutory guides',
        SYSTEM_MAPPING: 'Account used by a system accounting mapping',
        PAYROLL_JOURNAL: 'Payroll journal entry in the withholding account',
        GUIDE_JOURNAL: 'Guide journal entry in the withholding account',
        NON_AP_JOURNAL: 'Journal entry without an AP withholding origin',
        NON_AP_ORIGIN_PRESENT: 'Account shared with another accounting origin',
        AP_TAX_LINE_UNCLASSIFIED: 'AP journal entry without an identified withholding type',
        AP_TAX_LINE_WRONG_KIND: 'Journal withholding type does not match the account',
        NO_MAPPING: 'No valid GL account for the withholding on the event date',
        AMBIGUOUS_MAPPING: 'More than one possible GL account for the withholding',
      },
    },
    exclusions: {
      fxBook: {
        entity: 'Entity',
        book: 'Book',
        apCurrency: 'Accounts payable currency',
        bookCurrency: 'Book functional currency',
      },
      sourceTypes: { JOURNAL: 'Journal', BILL: 'Bill', PAYMENT: 'Payment' },
      status: 'Status',
      statusValues: {
        DRAFT: 'Draft',
        SUBMITTED: 'Submitted',
        PENDING_APPROVAL: 'Awaiting approval',
        APPROVED: 'Approved',
        REJECTED: 'Rejected',
        PARTIALLY_PAID: 'Partially paid',
        PAID: 'Paid',
        COMPLETED: 'Completed',
        VOID: 'Voided',
        MIGRATED: 'Migrated',
        RECONCILED: 'Reconciled',
        REVERSED: 'Reversed',
      },
      bill: 'Related bill',
      sourceEntity: 'Journal entry entity',
      currentEntity: 'Current entity',
      reason: 'Reason for exclusion',
      reasons: {
        billEntityChanged: 'Bill entity changed after the journal entry',
        compoundJournalWithTransfer: 'Compound journal entry includes a transferred bill',
        relatedJournalWithTransfer: 'Journal entry is related to a transferred bill',
        paymentJournalOtherEntity: 'Payment journal entry belongs to another entity',
      },
      otherReason: 'Entity history could not be verified',
      journal: 'Related journal',
      account: 'GL account',
    },
    accounts: {
      title: 'Differences by account',
      above: 'GL above',
      below: 'GL below',
      suppliers_one: '{{count}} supplier',
      suppliers_other: '{{count}} suppliers',
    },
    manual: {
      title: 'Manual entries without a supplier',
      item: 'manual line without a supplier',
    },
    other: {
      title: 'Other supplier items',
      item: 'supplier item',
    },
  },
  observations: {
    AP07_OPENING_NOT_INDEPENDENT_one:
      '{{count}} opening balance entry from the imported ledger, without an independent source in accounts payable, left out of the comparison',
    AP07_OPENING_NOT_INDEPENDENT_other:
      '{{count}} opening balance entries from the imported ledger, without an independent source in accounts payable, left out of the comparison',
    AP07_COMPOUND_PAYMENTS_one:
      '{{count}} payment in a compound entry without a separate supplier account, left out of the comparison',
    AP07_COMPOUND_PAYMENTS_other:
      '{{count}} payments in compound entries without separate supplier accounts, left out of the comparison',
    AP07_VENDOR_ADVANCES_one: '{{count}} supplier advance, left out of the comparison',
    AP07_VENDOR_ADVANCES_other: '{{count}} supplier advances, left out of the comparison',
    AP07_SHARED_WITHHOLDING_ACCOUNT_one:
      '{{count}} withholding tax account with activity from another source, left out of the AP comparison; reconcile in payroll and tax controls',
    AP07_SHARED_WITHHOLDING_ACCOUNT_other:
      '{{count}} withholding tax accounts with activity from another source, left out of the AP comparison; reconcile in payroll and tax controls',
    AP07_WITHHOLDING_MAPPING_UNRESOLVED_one:
      '{{count}} withholding with no identified GL account, left out of the comparison',
    AP07_WITHHOLDING_MAPPING_UNRESOLVED_other:
      '{{count}} withholdings with no identified GL account, left out of the comparison',
    AP07_REFUND_PAYMENTS_one: '{{count}} payment refund or adjustment, left out of the comparison',
    AP07_REFUND_PAYMENTS_other:
      '{{count}} payment refunds or adjustments, left out of the comparison',
    AP07_FOREIGN_CURRENCY_BILLS_one: '{{count}} foreign-currency bill, left out of the comparison',
    AP07_FOREIGN_CURRENCY_BILLS_other:
      '{{count}} foreign-currency bills, left out of the comparison',
    AP07_FX_BOOK_one:
      "The book's functional currency differs from the accounts payable currency: comparing amounts does not apply",
    AP07_FX_BOOK_other:
      "The book's functional currency differs from the accounts payable currency: comparing amounts does not apply",
    AP07_AP_CURRENCY_UNRESOLVED_one:
      'Entity functional currency is unresolved: the payables-to-ledger comparison cannot be completed',
    AP07_AP_CURRENCY_UNRESOLVED_other:
      'Entity functional currency is unresolved: the payables-to-ledger comparison cannot be completed',
    AP07_PAYMENTS_AWAITING_RECONCILIATION_one:
      '{{count}} payment awaiting reconciliation, left out of the comparison',
    AP07_PAYMENTS_AWAITING_RECONCILIATION_other:
      '{{count}} payments awaiting reconciliation, left out of the comparison',
    AP07_UNACCRUED_UNTRACED_PAYMENTS_one:
      '{{count}} payment with no accrued payable and no traceable journal entry, left out of the comparison',
    AP07_UNACCRUED_UNTRACED_PAYMENTS_other:
      '{{count}} payments with no accrued payable and no traceable journal entry, left out of the comparison',
    AP07_MIGRATED_BILL_PAYMENTS_UNPOSTED_one:
      '{{count}} payment of a migrated bill with no journal entry in the ledger, left out of the comparison',
    AP07_MIGRATED_BILL_PAYMENTS_UNPOSTED_other:
      '{{count}} payments of migrated bills with no journal entry in the ledger, left out of the comparison',
    AP07_TRANSFERRED_BILL_HISTORY_UNPROVEN_one:
      '{{count}} historical source of a bill transferred between entities without verified ownership in this period, left out of the comparison',
    AP07_TRANSFERRED_BILL_HISTORY_UNPROVEN_other:
      '{{count}} historical sources of bills transferred between entities without verified ownership in this period, left out of the comparison',
    other_one: '{{count}} item left out of the comparison ({{code}})',
    other_other: '{{count}} items left out of the comparison ({{code}})',
  },
};
